import { FunctionComponent, ReactNode } from 'react'
import styles from './dialogBody.module.scss'

interface DialogBodyProps {
    children?: ReactNode
    className?: string
}

const DialogBody: FunctionComponent<DialogBodyProps> = ({ children, className }: DialogBodyProps) => {
    return <div className={`${styles.Root} ${className}`}>{children}</div>
}

export default DialogBody
